export const HEADER_HEIGHT = 64;
export const HEADER_HEIGHT_SM = 48;
export const DEFAULT_RAILBAR_WIDTH = 360;
